export default __webpack_public_path__ + "static/media/500-error.cdedd0c1.png";